<template>
  <apexchart
    :type="dataSource.type || 'line'"
    :height="dataSource.height"
    :options="dataSource.chartOptions"
    :series="dataSource.series"
  ></apexchart>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dataSource: {
      type: Object,
      required: true,
      default: undefined,
    },
  },
};
</script>
